import React, { useState } from "react";
import PropTypes from "prop-types";
import { Field, withFormik } from "formik";
import { useTranslation } from "react-i18next";
import {
  dataModel,
  validationDataModel,
  setInitialValues,
} from "./meetingFilter.data.form";
import {
  InputText,
  InputSelect,
  InputAutoComplete,
  InputDate,
} from "@de-prado-dev/react-component-library";

import {
  FilterAccordion,
  AccordionItem,
  AccordionHeader,
  AccordionButton,
  AccordionCollapse,
  AccordionBody,
  FilterForm,
  FilterRow,
  FilterCol,
  FilterActions,
  FilterButtonPrimary,
  FilterButtonSecondary,
} from "../../session/sessionListNew/sessionListNew.styled";

import { COUNTRIES } from "../../../../constants";

const MeetingFilterForm = (props) => {
  const { t } = useTranslation();
  const { handleSubmit, onClean, coursesValues, onFilterFinca, onAddFarm } =
    props;
  const renderListFinca = (item) => {
    return item.label;
  };

  const months = [
    { month: t("forms.meeting.constants.january"), value: "01" },
    { month: t("forms.meeting.constants.february"), value: "02" },
    { month: t("forms.meeting.constants.march"), value: "03" },
    { month: t("forms.meeting.constants.april"), value: "04" },
    { month: t("forms.meeting.constants.may"), value: "05" },
    { month: t("forms.meeting.constants.june"), value: "06" },
    { month: t("forms.meeting.constants.july"), value: "07" },
    { month: t("forms.meeting.constants.august"), value: "08" },
    { month: t("forms.meeting.constants.september"), value: "09" },
    { month: t("forms.meeting.constants.october"), value: "10" },
    { month: t("forms.meeting.constants.november"), value: "11" },
    { month: t("forms.meeting.constants.december"), value: "12" },
  ];

  return (
    <>
      <FilterAccordion>
        <AccordionItem>
          <AccordionHeader>
            <AccordionButton
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#filterCollapse"
              aria-expanded="false"
              aria-controls="filterCollapse"
            >
              <i className="fas fa-filter"></i>
              {t("forms.meeting.filter")}
            </AccordionButton>
          </AccordionHeader>
          <AccordionCollapse
            id="filterCollapse"
            className="accordion-collapse collapse"
          >
            <AccordionBody>
              <FilterForm onSubmit={handleSubmit} autoComplete="off">
                <FilterRow>
                  <FilterCol>
                    <Field
                      id="courseUuid"
                      name="courseUuid"
                      labelField={t("forms.meeting.labels.course")}
                      component={InputSelect}
                      placeholder=""
                      optionLabel="label"
                      optionValue="code"
                      options={coursesValues.map((item) => ({
                        ...item,
                        label: t(item.label),
                      }))}
                      //onChangeValue={(value) => {
                      //  onSelectCourse(value);
                      //}}
                      classNamePrefix="dark"
                      mandatory
                      addOptionEmpty
                    />
                  </FilterCol>
                  <FilterCol>
                    <Field
                      id="farm"
                      className="form-control"
                      labelField={t("forms.meeting.labels.farm")}
                      name="farm"
                      mandatory
                      component={InputAutoComplete}
                      fieldType="text"
                      onSearch={onFilterFinca}
                      optionValue="value"
                      optionLabel="label"
                      textButtonReset={t("clear")}
                      renderItems={renderListFinca}
                      onSelect={onAddFarm}
                    />
                  </FilterCol>
                  <FilterCol>
                    <Field
                      id="month"
                      name="month"
                      component={InputSelect}
                      labelField={t("forms.meeting.labels.month")}
                      placeholder={t("forms.meeting.placeholders.selectMonth")}
                      optionLabel="month"
                      optionValue="value"
                      options={months}
                      classNamePrefix="dark"
                      addOptionEmpty
                    />
                  </FilterCol>
                  
                  {/* <FilterCol>
                    <Field
                      id="startDate"
                      className="form-control"
                      labelField={t("forms.meeting.labels.startDate")}
                      name="startDate"
                      placeholder=""
                      component={InputDate}
                      language="es"
                      dateFormat="dd/MM/yyyy"
                      defaultHours={0}
                      defaultMinutes={0}
                    />
                  </FilterCol>
                  <FilterCol>
                    <Field
                      id="endDate"
                      className="form-control"
                      labelField={t("forms.meeting.labels.endDate")}
                      name="endDate"
                      placeholder=""
                      component={InputDate}
                      language="es"
                      dateFormat="dd/MM/yyyy"
                      defaultHours={23}
                      defaultMinutes={59}
                    />
                  </FilterCol> */}
                </FilterRow>

                <FilterActions>
                  <FilterButtonPrimary type="submit">
                    <i className="fas fa-search"></i>
                    {t("search") || "Buscar"}
                  </FilterButtonPrimary>
                  <FilterButtonSecondary
                    type="button"
                    onClick={() => onClean(props.resetForm)}
                  >
                    <i className="fas fa-trash"></i>
                    {t("forms.cleanFilter")}
                  </FilterButtonSecondary>
                </FilterActions>
              </FilterForm>
            </AccordionBody>
          </AccordionCollapse>
        </AccordionItem>
      </FilterAccordion>
    </>
  );
};

MeetingFilterForm.propTypes = {
  handleSubmit: PropTypes.func,
  onClean: PropTypes.func,
};

const MeetingFilterFormF = withFormik({
  mapPropsToValues: (props) => {
    if (props.initialValues) {
      return setInitialValues(props.initialValues);
    }
    return dataModel;
  },
  validationSchema: validationDataModel,
  handleSubmit: (values, { props, resetForm }) => {
    props.onSubmit(values, resetForm);
  },
  enableReinitialize: true,
  displayName: "MeetingFilterForm",
})(MeetingFilterForm);

export default MeetingFilterFormF;
